/* Naissance & Co Paris — scroll reveal + smooth anchors */
(function () {
  'use strict';

  function init() {
    // Stagger siblings that opted in via data-nc-stagger on their parent.
    document.querySelectorAll('[data-nc-stagger]').forEach(function (parent) {
      var step = parseFloat(parent.getAttribute('data-nc-stagger')) || 0.12;
      Array.prototype.forEach.call(parent.children, function (child, i) {
        child.style.setProperty('--nc-delay', (i * step).toFixed(2) + 's');
      });
    });

    var revealed = document.querySelectorAll('.nc-reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealed.forEach(function (el) { io.observe(el); });
    } else {
      revealed.forEach(function (el) { el.classList.add('is-in'); });
    }

    // Smooth scroll for same-page anchors (hero CTA → first coffret).
    document.querySelectorAll('a[data-nc-scroll]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var id = a.getAttribute('href');
        if (!id || id.charAt(0) !== '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        ev.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Dondy free tier can't set the prefill text — rewrite wa.me links to French. */
(function () {
  'use strict';
  var FR = 'Bonjour, j’ai une question 😊';
  function fixLinks(root) {
    (root || document).querySelectorAll('a[href*="wa.me"], a[href*="api.whatsapp.com"]').forEach(function (a) {
      try {
        var u = new URL(a.href);
        u.searchParams.set('text', FR);
        a.href = u.toString();
      } catch (e) { /* leave as-is */ }
    });
  }
  var tries = 0;
  var t = setInterval(function () {
    fixLinks();
    if (++tries > 20) clearInterval(t);
  }, 1000);
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"]') : null;
    if (a) fixLinks(a.parentElement || document);
  }, true);
})();

/* Klaviyo popup: limit to once per session (config lives in Klaviyo's dashboard;
   this is a theme-side guard so the form never re-covers the hero on every page). */
(function () {
  'use strict';
  var KEY = 'nc-klaviyo-shown';
  function guard() {
    var forms = document.querySelectorAll('[class*="kl-private"], .klaviyo-form, [data-testid="klaviyo-form-modal"]');
    if (!forms.length) return;
    var shown = false;
    try { shown = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    forms.forEach(function (f) {
      var isOverlay = f.className && String(f.className).indexOf('kl-private-reset-css') > -1 && f.offsetHeight > 200;
      if (!isOverlay) return;
      if (shown) {
        f.style.display = 'none';
      } else {
        try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      }
    });
  }
  var n = 0;
  var iv = setInterval(function () {
    guard();
    if (++n > 30) clearInterval(iv);
  }, 800);
})();
